import React from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface UnauthorizedUnlockModalProps {
    opened: boolean;
    onClose: () => void;
}

export const UnauthorizedUnlockModal: React.FC<UnauthorizedUnlockModalProps> = ({ opened, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={t('prescriptionHistory.unauthorized.title')}
            size="md"
            centered
        >
            <Stack gap="sm">
                <Text size="sm">{t('prescriptionHistory.unauthorized.message')}</Text>
                <Group justify="flex-end" mt="md">
                    <Button onClick={onClose}>{t('button.ok')}</Button>
                </Group>
            </Stack>
        </Modal>
    );
};
